import { throwError } from "rxjs";
import { ajax, AjaxResponse } from "rxjs/ajax";
import { catchError } from "rxjs/operators";

// @ts-ignore
// export const baseURL = "https://naveedtazeen.com";
// // if its running on localHost get data from localHost otherwise from stg
export const baseURL = window.location.hostname === "localhost" ? "http://localhost" : "https://naveedtazeen.com";
const requestHeader = (is_required = false) => {
  let headers = {};
  if (!is_required) {
    headers = {
      // You can remove this line when sending FormData
      // "Content-Type": "multipar  t/form-data",
    };
  }

  return headers;
};

const handleError = (operation: string) => (err: AjaxResponse<object>) => {
  const errMsg = `Error in ${operation}()`;

  if (err.status === 401) {
    localStorage.clear();
    window.location.href = "/auth/login";
  }
  return throwError(() => console.error(errMsg));
};

export const CheckAppointmentDate = (date: string) => {
  return ajax({
    // headers: requestHeader(),
    method: "GET",
    // withCredentials: false,
    url: `${baseURL}/Server/checkdate.php?date=${date}`,
  }).pipe(catchError(handleError("CheckAppointmentDate")));
};

export const PostData = (data: { password: string }) => {
  const formData = new FormData();
  formData.append("password", data.password);

  return ajax({
    headers: requestHeader(), // 'Content-Type' is not required when sending FormData
    method: "POST",
    url: `${baseURL}/Server/login.php`,
    body: formData,
  }).pipe(catchError(handleError("PostData")));
};
export const DisableDays = (date: string) => {
  // const formData = new FormData();
  // formData.append('password', data.password);

  return ajax({
    headers: requestHeader(), // 'Content-Type' is not required when sending FormData
    method: "POST",
    url: `${baseURL}/Server/disable-book.php?date=${date}`,
    // body: formData,
  }).pipe(catchError(handleError("PostData")));
};
export const getAllAppointments = (date:string | Date) => {

  return ajax({
    // headers: requestHeader(),
    method: "GET",
    url: `${baseURL}/Server/getall.php?date=${date}`,
    // body: formData,
  }).pipe(catchError(handleError("PostData")));
};
export const GetBookedAppointments = (phone: any) => {
  return ajax({
    // headers: requestHeader(),
    method: "GET",
    url: `${baseURL}/Server/getapbyphone.php?phone=${phone}`,
  }).pipe(catchError(handleError("PostData")));
};
export const GetAvailablity = (date: any) => {
  return ajax({
    // headers: requestHeader(),
    method: "GET",
    url: `${baseURL}/Server/checkdate.php?date=${date}`,
  }).pipe(catchError(handleError("PostData")));
};
export const bookAppointment = (data: any) => {
  return ajax({
    // headers: requestHeader(),
    method: "POST",
    url: `${baseURL}/Server/book.php`,
    body: data,
  }).pipe(catchError(handleError("PostData")));
};
export const SendImage = (data: any) => {
  return ajax({
    // headers: requestHeader(),
    method: "POST",
    url: `${baseURL}/Server/sendaps.php`,
    body: data,
  }).pipe(catchError(handleError("PostData")));
};
export const getLogs = () => {
  return ajax({
    // headers: requestHeader(),
    method: "GET",
    url: `${baseURL}/Server/getlogs.php`,
  
  }).pipe(catchError(handleError("PostData")));
};
export const getDisableDays = () => {
  return ajax({
    // headers: requestHeader(),
    method: "GET",
    url: `${baseURL}/Server/fetch_rules.php`,
  
  }).pipe(catchError(handleError("PostData")));
};
export const deleteAppointment = (id:any) => {
  return ajax({
    // headers: requestHeader(),
    method: "DELETE",
    url: `${baseURL}/Server/delete.php?id=${id}`,
  
  }).pipe(catchError(handleError("PostData")));
};


export const deleteRule = (id:any) => {
  return ajax({
    // headers: requestHeader(),
    method: "DELETE",
    url: `${baseURL}/Server/deleterule.php?id=${id}`,
  
  }).pipe(catchError(handleError("PostData")));
};


export const update = (id:any,data:any) => {
  return ajax({
    // headers: requestHeader(),
    method: "PUT",
    url: `${baseURL}/Server/update.php?id=${id}`,
    body:{data}
  
  }).pipe(catchError(handleError("PostData")));
};



export const getNames = () => {
  return ajax({
    // headers: requestHeader(),
    method: "GET",
    url: `${baseURL}/Server/getnames.php`,
  
  }).pipe(catchError(handleError("PostData")));
};